// eslint-disable-next-line import/no-default-export
export default {
  tracking: {
    pauseModalPrefix: 'SUBSCRIPTION_PAUSE_MODAL_',
  },
}
